import React from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import BackArrow from "../../assets/svg/Back-Arrow.svg";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

const TransactionDetail = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const goToTransaction = () => {
    navigate("/account-transation");
  };
  // console.log(state?.transactionDetails.NetworkFee);
  return (
    <>
      <div className="wallet-transaction-wrapper">
        <Sidebar />
        <div className="container">
          <div className="spacing-wrapper">
            <div className="admin-page-header">
              <h2> Wallet Transaction </h2>
            </div>

            <div className="transactin-detail">
              <img onClick={goToTransaction} src={BackArrow} alt="arrow" />
              <h2> Details </h2>
            </div>

            <div className="transaction-detail-wrapper">
              <div className="transaction-detail-left">
                <h3> Invoice Information </h3>

                <div className="transaction-info-wrapper">
                  <div className="transaction-info-wrap">
                    <h4> Transaction ID : </h4>
                    <div>
                      {" "}
                      <h5>{state?.transactionDetails.TransectionId} </h5>
                    </div>
                  </div>

                  <div className="transaction-info-wrap">
                    <h4>Order Date :</h4>
                    <h5>
                      {moment(state?.transactionDetails.createdAt).format(
                        "D-MMM-YY"
                      )}
                    </h5>
                  </div>

                  <div className="transaction-info-wrap">
                    <h4>Date Completed :</h4>
                    <h5>
                      {moment(state?.transactionDetails.createdAt).format(
                        "D-MMM-YY"
                      )}{" "}
                      <span className="time">
                        {moment(state?.transactionDetails.createdAt).format(
                          "LTS"
                        )}{" "}
                      </span>
                    </h5>
                  </div>

                  <div className="transaction-info-wrap">
                    <h4>Order Status :</h4>
                    <h5>{state?.transactionDetails.StatusMessage}</h5>
                  </div>

                  <div className="transaction-info-wrap">
                    <h4>Type :</h4>
                    <h5>{state?.transactionDetails.PaymentType}</h5>
                  </div>
                  <div className="transaction-info-wrap">
                    <h4>Currency :</h4>
                    <h5>{state?.transactionDetails.Currency}</h5>
                  </div>

                  <div className="transaction-info-wrap">
                    <h4> Amount :</h4>
                    <h5>
                      {parseFloat(state?.transactionDetails.Amount).toFixed(6)}{" "}
                      {state?.transactionDetails.Currency}
                    </h5>
                  </div>
                </div>
              </div>

              <div className="transaction-detail-right">
                <h3> Account Information </h3>

                <div className="transaction-info-wrapper">
                  <div className="transaction-info-wrap">
                    <h4>Customer : </h4>
                    <h5>{state?.transactionDetails.DeviceId} </h5>
                  </div>

                  <div className="transaction-info-wrap">
                    <h4>Wallet Address :</h4>
                    <div>
                      {" "}
                      <h5> {state?.transactionDetails.ToWalletAddress}</h5>
                    </div>
                  </div>

                  <div className="transaction-info-wrap">
                    <h4> Device ID : </h4>
                    <h5> {state?.transactionDetails.DeviceId}</h5>
                  </div>
                </div>
              </div>
            </div>

            <div className="transaction-detail-table-wrapper">
              <table className="table table-striped">
                <thead style={{ textAlign: "center" }}>
                  <tr>
                    <th>Units Filled</th>
                    <th>Units Total</th>
                    <th>Fee</th>
                    <th>Network Fee</th>
                  </tr>
                </thead>
                <tbody style={{ textAlign: "center" }}>
                  <tr>
                    <td>{state?.transactionDetails.Currency}</td>
                    <td>
                      {" "}
                      {moment(state?.transactionDetails.createdAt).format(
                        "D-MMM-YY"
                      )}{" "}
                      {moment(state?.transactionDetails.createdAt).format(
                        "LTS"
                      )}
                    </td>
                    <td>
                      {parseFloat(
                        state?.transactionDetails.NetworkFee === undefined ||
                          state?.transactionDetails.NetworkFee === null
                          ? 0
                          : state?.transactionDetails.NetworkFee
                      ).toFixed(6)}{" "}
                      {state?.transactionDetails.Currency}
                    </td>
                    <td>
                      {" "}
                      {parseFloat(
                        state?.transactionDetails.NetworkFee === undefined ||
                          state?.transactionDetails.NetworkFee === null
                          ? 0
                          : state?.transactionDetails.NetworkFee
                      ).toFixed(6)}{" "}
                      {state?.transactionDetails.Currency}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="transaction-table-total-wrap">
              <div className="transaction-total-wrapper">
                <div className="transaction-total-wrap">
                  <h4>SubTotal : </h4>
                  <h5>
                    {" "}
                    {parseFloat(state?.transactionDetails.Amount).toFixed(
                      6
                    )}{" "}
                    {state?.transactionDetails.Currency}{" "}
                  </h5>
                </div>
                <div className="transaction-total-wrap">
                  <h4>Fees : </h4>
                  <h5>
                    {" "}
                    {parseFloat(
                      state?.transactionDetails.Fee === undefined ||
                        state?.transactionDetails.Fee === null
                        ? 0
                        : state?.transactionDetails.Fee
                    ).toFixed(6)}{" "}
                    {state?.transactionDetails.Currency}{" "}
                  </h5>
                </div>
                <div className="transaction-total-wrap">
                  <h4>Our Fees : </h4>
                  <h5>
                    {parseFloat(
                      state?.transactionDetails.NetworkFee === undefined ||
                        state?.transactionDetails.NetworkFee === null
                        ? 0
                        : state?.transactionDetails.NetworkFee
                    ).toFixed(6)}{" "}
                    {state?.transactionDetails.Currency}{" "}
                  </h5>
                </div>

                <div className="transaction-total-wrap">
                  <h4>Total Profit : </h4>
                  <h5>
                    {" "}
                    {parseFloat(state?.transactionDetails.Amount).toFixed(
                      6
                    )}{" "}
                    {state?.transactionDetails.Currency}{" "}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionDetail;
